/** Catálogo inglés — claves planas; añade módulos como `battlepass.title` si crece el proyecto */
const en = {
  unique_death_history: "Death history",
  reg_events: "Events",
  reg_details: "Details & rewards",
  reg_details_pending: "Details will be announced soon.",
  reg_open: "Open",
  reg_closed: "Closed",
  reg_joined: "Registered",
  reg_equalized: "Equalized",
  reg_standard: "Standard",
  reg_cancel_registration: "Cancel registration",
  reg_joined_hint: "You are registered for this event.",
  reg_open_hint: "Registration is open. Choose Register to join.",
  reg_closed_hint: "Registration is closed.",
  reg_translating: "Translating…",
  reg_translation_error: "Translation unavailable. Showing the original text.",
  reg_retry: "Retry",

  battle_pass: 'Battle Pass',
  menu_main: 'Main menu',
  menu_tools: 'Tools',
  menu_open: 'Open menu',
  menu_close: 'Close menu',
  menu_home: 'Back to home',
  guide: 'Guide',
  daily_login: 'Daily login',
  spin_title: 'Wheel',
  special_offer: 'Special Offer',
  auction_system: 'Auction House',
  title_manager: 'Customization',
  ranking: 'Ranking',
  unique: 'Unique',
  job_system: 'Job System',
  vip_system: 'VIP',
  donation: 'Donation',
  surveys: 'Surveys',
  settings: 'Settings',
  messages: 'Messages',
  unique_status_title: 'Current Status',
  unique_logs_title: 'History Log',
  unique_table_name: 'Unique',
  unique_table_character: 'Character',
  unique_table_status: 'Status',
  unique_table_event: 'Event',
  unique_table_map: 'Map',
  unique_table_time: 'Time',
  unique_status_alive: 'Alive',
  unique_status_dead: 'Dead',
  unique_event_spawn: 'Spawn',
  unique_event_death: 'Kill',
  unique_refresh: 'Refresh',
  unique_sort_alive_first: 'Sort: alive first',
  unique_sort_dead_first: 'Sort: dead first',
  unique_deaths_tooltip_title: 'Last 5 kills',
  unique_deaths_empty: 'No kills recorded',
  unique_load_error: 'Could not load unique history.',
  unique_no_data: 'No data found.',
  unique_logs_empty: 'No history events yet.',
  schedule: 'Schedule',
  sched_no_events: 'No events scheduled.',
  sched_running: 'RUNNING',
  sched_load_error: 'Could not load schedule. Try again later.',
  reg_register: 'Register',
  reg_remove_register: 'Remove registration',
  reg_processing: 'Processing...',
  reg_registered_success: 'You have successfully registered for the event',
  reg_unregistered_success: 'You have successfully unregistered from the event',
  reg_no_events: 'No events available.',
  reg_load_error: 'Could not load events. Try again later.',
  reg_error_invalid_event: 'Invalid event',
  reg_error_not_logged_in: 'You must be logged in to register for events',
  reg_error_not_available: 'The event is not available for registration',
  reg_error_already_registered: 'Error registering for event. You may already be registered.',
  reg_error_unregister: 'Error unregistering from event',
  reg_error_processing: 'Error processing request',
  reg_error_connection: 'Connection error. Please try again.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'Weapons (Select 1)',
  reg_buffs: 'Buffs (Select 1)',
  reg_essence: 'Essence (Always active)',
  reg_force: 'Force (Always active)',
  reg_btn_register: 'Register',
  reg_btn_cancel: 'Cancel',
  register: 'Register',
  r_ia: 'R-AI',
  chat_welcome_message: 'Hello! 👋 I am <strong>R-AI</strong>, your AI assistant for Silkroad Origins.',
  chat_welcome_question: 'How can I help you today?',
  chat_input_placeholder: 'Type your message...',
  chat_send_button: 'Send',
  chat_send_title: 'Send message',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'Could not load chat history. Try again later.',
  chat_error_connection: 'Connection error. Please try again.',
  drop_log: 'Drop Log',
  log_table_item: 'Item',
  log_table_character: 'Character',
  log_table_monster: 'Monster',
  log_table_map: 'Map',
  log_table_date: 'Date',
  log_table_ago: 'Ago',
  log_search_placeholder: 'Search...',
  log_time_seconds: 'sec',
  log_time_minutes: 'min',
  log_time_hours: 'h',
  log_time_days: 'd',
  log_filter_race: 'Race',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'European',
  log_filter_type: 'Type',
  log_filter_time_all: 'All',
  log_filter_time_today: 'Today',
  log_filter_time_week: 'This Week',
  log_filter_time_month: 'This Month',
  log_filter_apply: 'Apply',
  log_filter_reset: 'Reset',
  log_load_error: 'Could not load drop log. Try again later.',
  log_no_results: 'No drops match your filters.',
  log_modal_i_need_it: 'I Need It',
  log_modal_sending: 'Sending...',
  log_modal_sent: 'Sent',
  log_modal_error: 'Error',
  log_modal_connection_error: 'Connection error',
  log_modal_message_template: "Hi, I'm interested in the {item} you dropped. How much are you asking?",
  log_chat_button_title: 'Contact via chat',
  log_chat_self_error: 'Cannot send messages to yourself',
  languages: 'Languages',
  server_time: 'Server Time',
  loading_data: 'Loading data...',
  auth_loading: 'Authenticating...',
  auth_error: 'Could not authenticate. Reopen from the game.',
  bp_duration: 'Duration: {start} - {end} ({remaining} remaining)',
  bp_days_remaining: '{days} DAYS REMAINING',
  bp_day_remaining: '1 DAY REMAINING',
  bp_level: 'Level',
  bp_level_hero: 'LEVEL {level}',
  bp_levelup_cta: 'LEVEL UP',
  bp_season: 'SEASON {id}',
  bp_buy_pass: 'Buy Pass',
  bp_unlock_premium: 'Unlock Premium Pass',
  bp_premium_active: 'Premium pass active',
  bp_premium_reward: 'Premium Reward',
  bp_track_premium: 'Premium',
  bp_track_free: 'Free',
  bp_max_level: 'Max Level: {level}',
  bp_preview_level_btn: 'LEVEL {level}',
  bp_no_active: 'No active battle pass',
  bp_reward_success: 'Reward claimed successfully!',
  bp_claim_error: 'Could not claim reward. Try again later.',
  bp_exp_info_title: 'Battle Pass Experience',
  bp_exp_tower_defense_victory: 'Tower Defense: Victory: 45 points | Defeat: 5 points',
  bp_exp_hell_prison_victory: 'Hell Prison: Victory: 50 points | Defeat: 10 points',
  bp_exp_witch_hunt_victory: 'Witch Hunt: Victory: 50 points | Defeat: 10 points',
  bp_exp_survival: 'Survival: 1st Place: 30 Points | 2nd Place: 15 points | 3rd Place: 5 points',
  bp_exp_last_man_standing: 'Last Man Standing: Victory: 95 points',
  bp_exp_madness: 'Madness: 1st Place: 30 Points | 2nd Place: 15 points | 3rd Place: 5 points',
  bp_exp_garden_job_victory: 'Garden (Job): Victory: 50 points | Defeat: 10 points',
  bp_exp_capture_flag_victory: 'Capture the Flag: Victory: 50 points | Defeat: 10 points',
  bp_exp_battle_arena_victory: 'Battle Arena: Victory: 50 points | Defeat: 10 points',
  bp_exp_league_map_victory: 'League Map: Victory: 55 points | Defeat: 10 points',
  bp_exp_medusa_victory: 'Medusa: Victory: 100 points | Defeat: 20 points',
  bp_exp_roc_victory: 'Roc: Victory: 100 points | Defeat: 20 points',
  bp_exp_normal_uniques_victory: 'Normal Uniques: Victory: 5 points | Defeat: 3 points',
  bp_exp_arabian_uniques_victory: 'Arabian Uniques: Victory: 7 points | Defeat: 5 points',
  bp_exp_legendary_uniques_victory: 'Legendary Uniques: Victory: 10 points | Defeat: 7 points',
  bp_exp_job_kills: 'Job Kills: 2 points per kill',
  bp_exp_job_delivery: 'Job Delivery: 15 points per delivery',
  bp_exp_global_chat: 'Global Chat Use: 2 points per global chat use',
  bp_exp_summary:
    'Gain BP XP from events: Tower Defense, Hell Prison, Witch Hunt, Survival, Madness, Garden Job, Capture Flag, Battle Arena, League Map, Medusa, Roc, Uniques, Job kills/delivery, and Global Chat.',
  silk_confirm_cost: 'Cost: {amount} Silks',
  silk_confirm_balance: 'Your balance: {amount} Silks',
  silk_confirm_after: 'Balance after purchase: {amount} Silks',
  silk_confirm_not_enough: 'You do not have enough Silks for this purchase.',
  silk_confirm_cancel: 'Cancel',
  silk_confirm_confirm: 'Confirm',
  bp_premium_confirm_title: 'Buy Premium Pass',
  bp_premium_confirm_msg: 'Unlock all premium rewards for this season.',
  bp_levelup_confirm_title: 'Level Up',
  bp_levelup_confirm_msg: 'Instantly gain one Battle Pass level.',
  silk_confirm_price_label: 'Price',
  silk_confirm_your_silk: 'Your Silk',
  silk_confirm_checking: 'Checking...',
  silk_confirm_unavailable: 'Unavailable',
  silk_confirm_retry_later: 'Retry Later',
  silk_confirm_not_enough_short: 'Not Enough Silk',
  silk_confirm_processing: 'Processing',
  silk_confirm_processing_msg: 'Processing your purchase...',
  silk_confirm_success: 'Success',
  silk_confirm_failed: 'Failed',
  silk_confirm_wait: 'Please Wait',
  silk_confirm_close: 'Close',
  cal_schedule_label: 'Check-In Schedule: {start} - {end}',
  cal_remaining_label: '({remaining} remaining)',
  cal_checked_in_status: 'Checked in {checked} out of {total} days ({missed} day(s) missed)',
  cal_day_label: 'Day {day}',
  cal_checkin_available: 'You can check-in now!',
  cal_next_checkin: 'Next check-in in: {hours}h {minutes}m',
  cal_claim_error: 'Could not complete action. Try again later.',
  cal_no_campaign: 'No active campaign',
  spin_daily_spins: '{max} Daily Spins ({used}/{max})',
  spin_recent_rewards: 'Last 5 Recent Rewards',
  spin_congratulations: 'Congratulations!',
  spin_probability: 'Probability:',
  spin_daily_reached_tooltip: 'Daily reached. To use again, buy with Silk.',
  spin_reset_confirm_title: 'Confirm Reset',
  spin_reset_confirm_message: 'Are you sure you want to reset spins?',
  spin_reset_confirm_silk: '{amount} silks',
  spin_reset_confirm_cancel: 'Cancel',
  spin_reset_confirm_confirm: 'Confirm',
  spin_reset_success: 'Spins reset successfully!',
  spin_reset_error: 'Could not reset spins.',
  spin_error_spin: 'Could not spin the wheel.',
  spin_error_winner: 'Winning item not found.',
  spin_error_connection: 'Connection error with the server.',
  so_title: 'Special Offer',
  so_recommended: 'Recommended',
  so_offer_ends_in: 'Offer ends in',
  so_buy: 'BUY',
  so_available: 'Available',
  so_sold_out: 'Sold out',
  so_processing: 'Processing...',
  so_purchase_success: 'Purchase successful!',
  so_purchase_error: 'Purchase error',
  so_network_error: 'Network error',
  so_confirm_title: 'Confirm Purchase',
  so_confirm_message: 'Buy {name}?',
  so_no_offers: 'No active offers',
  auc_time_left: 'Time left',
  auc_bid_concluded: 'Bid Concluded',
  auc_winner: 'Winner',
  auc_auction_starting_soon: 'Auction starting soon',
  auc_enter_bid: 'Enter your bid',
  auc_bid_now: 'Bid Now',
  auc_be_first_to_bid: 'Be the first to bid',
  auc_current_bid: 'Current Bid',
  auc_by: 'by',
  auc_latest_bids: 'Latest Bids',
  auc_auction_ended: 'Auction has ended. Congratulations to the winner!',
  auc_wait_next_auction: 'Please wait for the next auction to start.',
  auc_item_rewards: 'Item Rewards',
  auc_no_rewards: 'No rewards available',
  auc_bid_success: 'Bid placed successfully!',
  auc_bid_error: 'Error placing bid.',
  auc_invalid_bid: 'Enter a valid bid amount.',
  tm_tab_name: "Name",
  tm_name_colors: "Saved name colors",
  tm_name_apply: "Apply color",
  tm_name_select: "Select a color",
  tm_name_empty: "No saved colors yet.",
  tm_name_reuse: "Each color costs 999 Silks. Purchased colors can be reused for free. Wait 30 seconds between customization changes.",
  tm_name_buy: "Buy name color",
  tm_name_purchased: "Name color purchased.",
  tm_name_applied: "Name color applied.",
  tm_name_owned: "Already owned",
  tm_name_error: "Could not process name color.",
  tm_cooldown: "Wait {seconds} seconds before another change.",
  tm_tab_title: 'Title',
  tm_tab_icon: 'Icon',
  tm_tab_tag: 'Tag',
  tm_title_column: 'Title',
  tm_tag_column: 'Tag',
  tm_actions_column: 'Actions',
  tm_enter_title: 'Enter title text...',
  tm_enter_tag: 'Enter tag text...',
  tm_test: 'Test',
  tm_edit: 'Edit',
  tm_edit_title_modal_title: 'Edit Title',
  tm_price_edit: 'Edit Price',
  tm_error_editing_title: 'Error editing title.',
  tm_title_edited: 'Title updated successfully.',
  tm_buy: 'Buy',
  tm_total_pay: 'Total to pay',
  tm_color_optional: 'Custom color (optional)',
  tm_edit_separate: 'Edit an existing title (separate)',
  tm_price_title: 'Title Price',
  tm_price_color: 'Color Price',
  tm_price_tag: 'Tag Price',
  tm_price_icon_label: '{amount} Silks',
  tm_apply_title: 'Apply Title',
  tm_remove_title: 'Remove Title',
  tm_apply_tag: 'Apply Tag',
  tm_remove_tag: 'Remove Tag',
  tm_no_titles: 'No saved titles.',
  tm_no_tags: 'No saved tags.',
  tm_no_icons: 'No icons found.',
  tm_icon_search: 'Search icons...',
  tm_icon_left: 'Left Icon',
  tm_icon_right: 'Right Icon',
  tm_buy_title_modal_title: 'Confirm Title Purchase',
  tm_buy_tag_modal_title: 'Confirm Tag Purchase',
  tm_buy_icon_modal_title: 'Confirm Icon Purchase',
  tm_buy_title_label: 'Title:',
  tm_buy_tag_label: 'Tag:',
  tm_buy_icon_label: 'Icon:',
  tm_buy_price_label: 'Price:',
  tm_buy_balance_label: 'Your balance:',
  tm_buy_includes: 'Includes:',
  tm_buy_includes_title_color: 'Title + Custom Color',
  tm_buy_not_enough: "⚠ You don't have enough Silks.",
  tm_buy_needs_more: 'You need {amount} more Silks.',
  tm_buy_confirm: 'Confirm Purchase',
  tm_buy_cancel: 'Cancel',
  tm_error_testing_title: 'Error testing title.',
  tm_error_buying_title: 'Error buying title.',
  tm_error_buying_tag: 'Error buying tag.',
  tm_error_buying_icon: 'Error buying icon.',
  tm_error_applying_icon: 'Error applying icon.',
  tm_error_getting_balance: 'Error getting Silk balance.',
  tm_error_applying_title: 'Error applying title.',
  tm_error_applying_tag: 'Error applying tag.',
  tm_error_removing_title: 'Error removing title.',
  tm_error_removing_tag: 'Error removing tag.',
  tm_processing: 'Processing...',
  tm_already_have_title: 'You already have this title.',
  tm_already_have_tag: 'You already have this tag.',
  tm_already_have_icon: 'You already own this icon.',
  tm_not_enough_silk: 'Not enough Silk.',
  tm_title_applied: 'Title applied successfully.',
  tm_title_purchased: 'Title purchased! Enjoy your new title.',
  tm_tag_applied: 'Tag applied successfully.',
  tm_icon_applied: 'Icon applied successfully.',
  tm_title_removed: 'Title deactivated successfully.',
  tm_tag_removed: 'Tag removed successfully.',
  tm_icon_purchased: 'Icon purchased successfully.',
  tm_test_applied: 'Title preview applied (temporary).',
  ranking_search_placeholder: 'Search player...',
  ranking_filter_race: 'Race',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: 'Mastery',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'Warrior',
  ranking_mastery_rogue: 'Rogue',
  ranking_mastery_wizard: 'Wizard',
  ranking_filter_reset: 'Reset',
  ranking_filter_refresh: 'Refresh ranking',
  ranking_col_character: 'Character',
  ranking_col_guild: 'Guild Name',
  ranking_col_points: 'Points',
  ranking_no_results: 'No players match your filters.',
  ranking_empty: 'Ranking data is not available yet. Try again later.',
  ranking_error: 'Could not load ranking. Tap ↺ to retry.',
  ranking_error_auth: 'Could not load ranking. Tap ↺ to retry.',
  ranking_player_title: 'Player Ranking',
  ranking_guild_title: 'Guild Ranking',
  ranking_mastery_title: 'Mastery Ranking',
  ranking_arena_title: 'Arena PVP Ranking',
  ranking_profile_loading: 'Loading character profile...',
  ranking_profile_error_title: 'Error',
  ranking_profile_error_message: 'Could not load character profile.',
  ranking_profile_back: 'Back to Ranking',
  ranking_profile_inventory: 'Inventory',
  ranking_profile_avatar: 'Avatar',
  ranking_profile_level: 'Lv.',
  ranking_profile_strength: 'Str:',
  ranking_profile_intelligence: 'Int:',
  ranking_profile_guild: 'Guild:',
  ranking_profile_no_guild: '<none>',
  job_level: 'Level',
  job_daily_progress: 'Daily work progress',
  job_claimed: 'Claimed',
  job_completed: 'Completed',
  job_in_progress: 'In Progress',
  job_gold: 'Gold',
  job_min: 'min',
  job_delivery_history: "Today's Delivery History",
  job_route: 'Route',
  job_gold_earned: 'Gold Earned',
  job_delivery_time: 'Delivery Time',
  job_delivery_hour: 'Delivery Hour',
  job_no_deliveries_today: 'No deliveries registered today.',
  job_no_job_info: 'No job information available for your character.',
  job_login_required: 'You must log in to view your job progress.',
  job_hwid_error: 'Could not retrieve hardware information.',
  job_level_error: 'Could not retrieve job level.',
  job_no_configuration: 'No configuration available for this job type.',
  job_merchant: 'Merchant',
  job_thief: 'Thief',
  job_hunter: 'Hunter',
  job_unknown: 'Unknown',
  job_invalid_data: 'Invalid data',
  job_already_claimed_today: "You have already claimed today's reward.",
  job_complete_progress_first: 'You must complete the daily progress before claiming the reward.',
  job_no_reward_for_level: 'No reward available for your current level.',
  job_reward_claimed_success: 'Reward claimed successfully.',
  job_success: 'Success',
  job_error: 'Error',
  job_network_error: 'Network error',
  job_protected_cargo: 'Protected cargo',
  job_stolen_cargo: 'Stolen cargo',
  cupon_title: 'Coupons',
  cupon_level_required: 'Level',
  cupon_rewards_title: 'Coupon Rewards',
  cupon_expires_in: 'Expires in',
  cupon_claim_button: 'Claim Coupon',
  cupon_claimed_button: 'Claimed',
  cupon_confirm_button: 'Confirm',
  cupon_resend_button: 'Resend code',
  cupon_verification_title: 'Enter verification code',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: 'A verification code will be sent to your email',
  cupon_code_sent_button: 'Sent - Check your email',
  cupon_coupon_claimed: 'Coupon claimed successfully! Check your chest in game.',
  cupon_no_coupons: 'No coupons available at this time',
  cupon_already_claimed: 'You have already claimed this coupon',
  cupon_request_error: 'Error requesting code. Try again.',
  cupon_complete_code: 'You must enter the complete 6-digit code',
  cupon_processing_error: 'Error processing request. Try again.',
  cupon_sending: 'Sending...',
  cupon_processing: 'Processing...',
  settings_tab_general: 'General',
  settings_tab_notifications: 'Notifications',
  settings_tab_restrictions: 'Restrictions',
  settings_label_language: 'Language',
  settings_label_timezone: 'Timezone',
  settings_label_country: 'Country',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: 'Verify',
  settings_btn_confirm: 'Confirm',
  settings_btn_save: 'Save',
  settings_btn_validate_now: 'Validate Now',
  settings_btn_validate_whatsapp: 'Validate via WhatsApp',
  settings_btn_validate_authenticator: 'Validate via Authenticator',
  settings_placeholder_code: 'Code',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'No events configured',
  settings_minutes_before: 'min before',
  settings_time_remaining: 'Time remaining until next validation required',
  settings_validation_warning: 'Your validation will expire soon. Renew now to continue playing without interruption.',
  settings_validation_active: 'Your connection is validated and active.',
  settings_validation_expired: 'You must validate your connection to move in game.',
  settings_coming_soon: '(Coming soon)',
  settings_no_hwid: 'Could not obtain HWID. Please log in to the game.',
  settings_code_sent: 'Code sent. Check your WhatsApp.',
  settings_whatsapp_verified_success: 'WhatsApp verified successfully',
  settings_error_update_config: 'Error updating configuration',
  settings_error_phone_required: 'Please enter a phone number',
  settings_error_code_required: 'Please enter a valid 6-digit code',
  settings_error_send_code: 'Error sending verification code',
  settings_error_verify_code: 'Error verifying code',
  settings_error_validate_connection: 'Error validating connection',
  settings_error_code_incorrect: 'Incorrect code',
  settings_no_results: 'No results found',
  settings_searching: 'Search...',
  messages_page_title: 'Chat',
  messages_conversations: 'Conversations',
  messages_new_chat: 'New Chat',
  messages_search_player: 'Search player...',
  messages_type_message: 'Type a message...',
  messages_send: 'Send',
  messages_attach_item: 'Attach Item',
  messages_online: 'Online',
  messages_offline: 'Offline',
  messages_no_messages: 'No messages yet',
  messages_no_conversations: 'No conversations',
  messages_loading: 'Loading...',
  messages_error_send: 'Error sending message',
  messages_error_load: 'Error loading messages',
  messages_retry: 'Retry',
  messages_select_player: 'Select a player to start chatting',
  messages_select_item: 'Select an item',
  messages_item_attached: 'Item attached',
  messages_remove_item: 'Remove item',
  messages_confirm: 'Confirm',
  messages_cancel: 'Cancel',
  messages_today: 'Today',
  messages_yesterday: 'Yesterday',
  messages_typing: 'typing...',
  messages_translate: 'Translate',
  messages_show_original: 'Show original',
  messages_translate_error: 'Could not translate message',
  messages_scroll_for_more: 'Scroll up for older messages',

  notifications_title: 'Notifications',
  notifications_no_notifications: 'No notifications available',
  notifications_no_type: 'No type',
  notifications_published: 'Published:',
  notifications_expires: 'Expires:',
  notifications_like: 'Like',
  notifications_dislike: 'Dislike',
  notifications_back_to_notifications: 'Back to Notifications',
  notifications_vote_error: 'Error updating vote',
  notifications_loading: 'Loading...',
  notifications_error_load: 'Error loading notifications',
  notifications_not_found: 'Notification not found or not available',

  dt_title: 'Daily Tasks',
  dt_global_progress: 'Global Progress',
  dt_tasks_completed: 'tasks completed',
  dt_no_tasks: 'No tasks available at this time.',
  dt_claimed: 'Claimed',
  dt_incomplete: 'Incomplete',
  dt_final_rewards: 'Final Rewards',
  dt_final_rewards_description:
    'Complete all daily tasks and claim all their rewards to unlock these final rewards.',
  dt_claim_final_reward: 'Claim Final Reward',
  dt_complete_all_first: 'You must complete and claim all daily tasks first',
  dt_success: 'Success',
  dt_error: 'Error',
  dt_network_error: 'Network error',
  dt_processing: 'Processing...',
  dt_login_required: 'You must be logged in to view daily tasks.',
  dt_load_error: 'Could not load daily tasks.',

  don_package: 'Package:',
  don_silks: 'Silks:',
  don_price: 'Price:',
  don_silks_label: 'silks',
  don_vip_points: '{amount} VIP Points',
  don_promo: 'Promo',
  don_special_offer: 'Special Offer',
  don_back: '← Back',
  don_pay: 'Pay $',
  don_continue_paypal: 'Continue to PayPal',
  don_processing: 'Processing...',
  don_binance_soon: 'Binance payment coming soon...',
  don_error_create: 'Error creating payment',
  don_stripe_not_loaded: 'Stripe SDK not loaded',
  don_success_processing: 'Processing payment...',
  don_success_wait: 'Please wait while we confirm your donation.',
  don_success_ok: 'Payment successful!',
  don_success_fail: 'Payment not completed',
  don_success_fail_msg: 'Your donation could not be confirmed. Please try again.',
  don_cancel_title: 'Payment cancelled',
  don_cancel_msg: 'Your donation was not completed. You can try again anytime.',
  don_back_to: 'Back to Donations',
  don_credited: '{amount} silks have been credited to your account.',
  cal_claimed: 'Claimed',
  cal_locked: 'Locked',
  cal_today: 'Today',
  cal_claim: 'Claim',
  cal_streak_label: 'Days checked in',
  cal_consecutive_login: 'Consecutive login',
  cal_upcoming: 'Upcoming',
  cal_upcoming_rewards: 'Upcoming rewards',
  cal_no_upcoming: 'None upcoming',
  cal_monthly_bonus: 'Monthly bonus',
  cal_monthly_bonus_desc: 'Check in for {days} days to claim the monthly bonus reward.',
  cal_days_remaining: '{days} days remaining',
  cal_day_remaining: '1 day remaining',
  cal_info_title: 'Event information',
  cal_default_desc: 'Log in every day to claim exclusive rewards. Miss a day? Keep going, the Empire awaits your return.',
  cal_prev: 'Previous',
  cal_next: 'Next',
  cal_bonus_days_unit: 'days',
  cal_bonus_n_day: '1 day',
  cal_bonus_n_days: '{days} days',
  cal_bonus_7_days: '7 days',
  cal_bonus_15_days: '15 days',
  cal_bonus_1_month: '1 month',
  bp_multiple_items: 'Multiple items available',
  vip_title: 'VIP System',
  vip_col_level: 'LEVEL',
  vip_col_progress: 'PROGRESS',
  vip_col_rewards: 'REWARDS',
  vip_col_state: 'STATE',
  vip_level_label: 'VIP Level ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: 'Locked',
  vip_note: 'For every $1 you donate, you will receive',
  vip_note_points: '10 VIP Points.',
  security_cancel_setup: 'Cancel setup',
  security_authenticator: "Authenticator",
  security_whatsapp: "WhatsApp",
  security_email: "Email",
  security_active: "Connection verified",
  security_required: "Verify your connection",
  security_duration: "Choose any method to unlock this connection for 24 hours.",
  security_remaining: "Time remaining",
  security_methods: "Verification method",
  security_ready: "Ready to use",
  security_not_configured: "Not configured",
  security_unavailable: "Security verification is temporarily unavailable.",
  security_authenticator_help: "Use a six-digit code from Google Authenticator, Microsoft Authenticator or another compatible app.",
  security_whatsapp_help: "Receive a one-time code on your verified WhatsApp number.",
  security_email_help: "Receive a one-time code at the email address registered to your account.",
  security_rules: "Each validation requires a new code. Email and WhatsApp codes expire in 10 minutes, with up to 5 attempts. Never share your codes.",
  security_email_missing: "No email registered. Update your account email first.",
  security_configure_phone: "Configure WhatsApp number",
  security_cancel: "Back to verification",
  security_remove: "Remove authenticator",
  security_remove_help: "Confirm with your authenticator, email or verified WhatsApp. You can set up a new authenticator afterward.",
  security_no_connection: "Open Settings from the game to verify this connection.",
  security_setup_title: "Set up your authenticator",
  security_setup_help: "Add your Republic account to the app, then confirm with its first code.",
  security_setup: "Set up authenticator",
  security_qr: "Scan this QR in your authenticator app",
  security_manual_key: "Manual setup key",
  security_secret_help: "Keep this key private. Setup expires in 10 minutes.",
  security_phone_label: "WhatsApp number with country code",
  security_resend: "Resend code",
  security_send: "Send verification code",
  security_code: "Six-digit verification code",
  security_confirm: "Confirm setup",
  security_validate: "Verify for 24 hours",
  security_request_error: "Could not complete the request. Please try again.",
  security_retry: "Retry",
  security_general_help: "Set your language and region. Manage verification methods in Restrictions.",
  don_history: 'Purchase history',
  don_history_loading: 'Loading purchases...',
  don_history_error: 'Could not load purchase history.',
  don_history_empty: 'No purchases yet.',
  don_history_date: 'Date',
  don_history_method: 'Method',
  don_history_status: 'Status',
  don_history_previous: 'Previous',
  don_history_next: 'Next',
  don_status_completed: 'Completed',
  don_status_pending: 'Pending',
  don_status_cancelled: 'Cancelled',
  don_status_failed: 'Failed',
  don_daily_limit: "You have spent {current} in the last 24 hours. This purchase of {amount} would bring your total to {total}, exceeding the {limit} limit. You have {remaining} available.",
  don_limit_available: "Available: {amount}",
  don_reset_ready: "Payments in the last 24h",
  don_reset_updating: "Resetting...",
  don_reset_error: "Limit unavailable",
  don_reset_in: "Resets in {time}",
  don_limit_locked: "You reached the payment limit. Wait for the countdown in the header to finish before making another payment.",
} as const;

export type MessageKey = keyof typeof en;
export default en;
